import styled, { css } from 'styled-components'
import { Icon, Text } from 'components'
import { StyledLinkFlex } from 'modules/shared/styles'

import { colors } from 'utils/colors'

const BaseTruncateStyle = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const BaseText = css`
  color: ${(p) => p.theme.colors.gray7};
`

export const IconWrapper = styled.div`
  display: flex;
  ${(p) => p.theme.font({ color: 'gray5', size: 14, weight: 'medium' })};
  overflow: hidden;
`

export const LeadInfoWrapper = styled(StyledLinkFlex)`
  display: block;
  text-decoration: none;
  width: 100%;
  height: 100%;

  .lead-status {
    color: ${(p) => p.theme.colors.red};
    text-decoration: none;
    font-style: italic;
    white-space: nowrap;
  }

  & {
    :visited #lead-details-wrapper div {
      color: ${(p) => p.theme.colors.defaultText};
    }

    :visited .lead-status {
      color: ${(p) => p.theme.colors.red};
      font-style: italic;
    }
  }

  &:hover {
    text-decoration: none;

    .lead-name {
      text-decoration: underline;
    }
  }
`

export const LeadDetailsWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.2rem;

  div {
    text-decoration: none;
    color: ${(p) => p.theme.colors.defaultText};
  }
`

export const LeadHeader = styled.div`
  display: flex;
  ${BaseTruncateStyle}
`

export const DateTime = styled.div`
  ${(p) => p.theme.font({ color: 'gray5', size: 13, weight: 'medium' })};
  letter-spacing: 0;
  ${BaseTruncateStyle}
`

export const ClosedDate = styled(DateTime)`
  color: ${(p) => p.theme.colors.red};
`

export const LeadName = styled.div`
  ${(p) => p.theme.font({ color: 'blue1', size: 14, weight: 'medium' })};
  ${BaseTruncateStyle}
`

export const LeadOwner = styled.div<{ color: keyof typeof colors }>`
  align-items: center;
  color: ${(p) => p.theme.colors[p.color]};
  display: flex;
  text-transform: capitalize;
  ${BaseTruncateStyle}
`
export const AdditionalOwner = styled.div`
  ${BaseText}
  ${BaseTruncateStyle}
`
export const AdditionalOwnerCount = styled.div`
  ${BaseText}
`

export const ConvertedBy = styled.div`
  ${BaseText}
`

export const ConvertedDate = styled.div`
  ${BaseText}
`

export const ClosedReason = styled.div`
  ${BaseText}
`
export const ClosedBy = styled.div`
  ${BaseText}
`

export const LeadCampaign = styled.div`
  text-transform: capitalize;
  ${BaseTruncateStyle}
`

export const LeadSource = styled.div`
  ${(p) => p.theme.font({ color: 'gray5', size: 13, weight: 'medium' })};
  letter-spacing: 0;
  line-height: 16px;
  padding-top: 10px;
  text-transform: capitalize;
  ${BaseTruncateStyle}
`

export const StyledIcon = styled(Icon)`
  ${(p) => p.theme.font({ color: 'gray5', size: 16, weight: 'normal' })};
  padding-right: 5px;
`
export const MarketPotential = styled.div`
  ${BaseTruncateStyle}
`

export const Status = styled.div`
  ${BaseTruncateStyle}
`

export const MarketPotentialHeader = styled.div`
  ${BaseTruncateStyle}
`

export const LeadTypeHeader = styled.div`
  ${BaseTruncateStyle}
`

export const PriorityHeader = styled.div`
  ${BaseTruncateStyle}
`

export const CampaignSourceHeader = styled.div`
  ${BaseTruncateStyle}
`

export const LeadOwnerHeader = styled.div`
  ${BaseTruncateStyle}
`

export const StatusHeader = styled.div`
  ${BaseTruncateStyle}
`

export const ClosedDateHeader = styled.div`
  ${BaseTruncateStyle}
`
export const ClosedReasonHeader = styled.div`
  ${BaseTruncateStyle}
`

export const LastActivityHeader = styled.div`
  ${BaseTruncateStyle}
`

export const LeadInDateHeader = styled.div`
  ${BaseTruncateStyle}
`

export const LastActivity = styled.div`
  ${BaseTruncateStyle}
`

export const LeadInfoHeader = styled(Text)`
  ${BaseTruncateStyle}
`

export const DeletedDate = styled(DateTime)`
  color: ${(p) => p.theme.colors.red};
`

export const DeletedReason = styled.div`
  ${BaseText}
`

export const DeletedBy = styled.div`
  ${BaseText}
`
